module.exports = __webpack_public_path__ + "img/113.1177c653.jpg";